import { FunctionComponent, ReactElement } from 'react';
import { Label, Tooltip, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BestInDentalV2 } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import ProfessionalBestInDentalWinnerRibbon from '~/images/best-in-dental-professional-ribbon-v2.png';

interface IProps {
  /**
   * Optional anchor override. Defaults to the winner badge itself so both
   * office-facing surfaces (ProfileCard, ConfirmCandidate) stay in sync:
   * the design-system `Label` gradient pill under the BID v2 flag (GOTU-4823),
   * or the legacy ribbon PNG when the flag is off — keeping today's production
   * surface unchanged until rollout completes.
   */
  Anchor?: ReactElement;
}

export const ProfessionalBestInDentalWinnerTooltip: FunctionComponent<IProps> = ({ Anchor }) => {
  const isBidV2 = useFeatureFlag(BestInDentalV2);

  const badge =
    Anchor ??
    (isBidV2 ? (
      <Label severity="gradient" variant="filled">
        BEST IN DENTAL
      </Label>
    ) : (
      <img
        alt="Best In Dental Winner Ribbon"
        src={ProfessionalBestInDentalWinnerRibbon}
        width={184}
        height={24}
      />
    ));

  return (
    <Tooltip
      title={
        <Typography as="span" bold color={colors.shades[0]}>
          This professional has earned GoTu’s Best in Dental badge, our highest recognition for
          reliability, professionalism, and excellence in patient care.
        </Typography>
      }
      placement="bottom"
    >
      {badge}
    </Tooltip>
  );
};
